import { createTheme } from "@mui/material/styles";

const birthdayDatePickerTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#fff !important",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: "#fff !important",
        },
      },
    },
  },
});

export const DatePickerStls = {
  backgroundColor: "var(--palette-datepicker-bg)",
};

export const DialogProps = {
  classes: { paper: "mobile-dp" },
};

export const componentProps = {
  leftArrowButton: { root: "#fff" },
  rightArrowButton: {},
};

export const OpenPickerButtonProps = { classes: { root: "black-back" } };
export const PopperProps = { placement: "bottom-end" };
export const PaperProps = {
  sx: {
    bgcolor: "var(--palette-datepicker-bg)",
    color: "var(--palette-white)",
  },
};

export default birthdayDatePickerTheme;
